import React from 'react';

const PrivacyPolicyPage = () => {
  return (
    <div className="privacy-page">
      <div className="page-header">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>Your privacy matters to us.</p>
        </div>
      </div>
      <section className="container py-5">
        <p className="section-description">
          This placeholder outlines how we collect and use data. For detailed policies, please contact us.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;